<span [class]="' badge ' + this.badgeClass + ' ' + this.classes" [ngClass]="{ 'badge-pill': pillBadge }" [attr.title]="title ? title : null" [style]="style">
	<ng-content></ng-content>
</span>